import { useEffect, useRef, useState } from 'react';

const steps = [
  { num: '01', icon: 'ri-login-circle-line', title: 'Ziyaretçi Giriş Yapar', desc: 'Platform açılır, ziyaretçi karşılama ekranıyla tanışır' },
  { num: '02', icon: 'ri-eye-line', title: 'Kampanyaları İnceler', desc: 'Tüm aktif kampanyalar listelenir, dikkat çekici kartlar gösterilir' },
  { num: '03', icon: 'ri-search-eye-line', title: 'Detay Sayfasına Geçer', desc: 'İlgisini çeken kampanyaya tıklar, detaylı bilgi alır' },
  { num: '04', icon: 'ri-route-line', title: 'Yönlendirilir', desc: 'Sistem ziyaretçiyi bir sonraki adıma akıllıca yönlendirir' },
  { num: '05', icon: 'ri-message-3-line', title: 'İletişime Geçer', desc: 'WhatsApp veya form üzerinden başvuru oluşturur' },
];

export default function HowItWorks() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="nasil-calisir" className="relative py-24 md:py-32 bg-[#0d1117] overflow-hidden">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#00d9ff]/5 rounded-full blur-[100px] pointer-events-none" />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block text-[#d4af37] text-xs font-bold uppercase tracking-[4px] mb-4">
            Nasıl Çalışır
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white leading-tight">
            Ziyaretçiden Müşteriye<br />
            <span style={{ background: 'linear-gradient(135deg, #00d9ff, #d4af37)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Dönüşüm Akışı
            </span>
          </h2>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line desktop */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00d9ff]/30 to-transparent" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((step, i) => (
              <div
                key={i}
                className={`relative group transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                {/* Arrow between steps (desktop) */}
                {i < steps.length - 1 && (
                  <div className="hidden lg:flex absolute -right-3 top-14 z-10 w-6 h-6 items-center justify-center">
                    <i className="ri-arrow-right-s-line text-[#00d9ff]/60 text-xl"></i>
                  </div>
                )}

                <div
                  className="rounded-2xl p-6 border border-white/10 group-hover:border-[#00d9ff]/40 transition-all duration-300 group-hover:-translate-y-2 h-full"
                  style={{ background: 'rgba(26, 26, 46, 0.7)', backdropFilter: 'blur(20px)' }}
                >
                  {/* Number badge */}
                  <div
                    className="inline-flex items-center justify-center w-10 h-10 rounded-full text-black text-sm font-black mb-4"
                    style={{ background: 'linear-gradient(135deg, #d4af37, #f4d03f)' }}
                  >
                    {step.num}
                  </div>

                  {/* Icon */}
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#00d9ff]/10 mb-4 group-hover:bg-[#00d9ff]/20 transition-colors">
                    <i className={`${step.icon} text-2xl text-[#00d9ff]`}></i>
                  </div>

                  <h3 className="text-white font-bold text-base mb-2">{step.title}</h3>
                  <p className="text-white/50 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Info box */}
        <div
          className={`mt-12 rounded-2xl p-6 md:p-8 border-l-4 border-[#00d9ff] transition-all duration-700 delay-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
          style={{ background: 'rgba(0, 217, 255, 0.05)', backdropFilter: 'blur(20px)' }}
        >
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00d9ff]/15 shrink-0">
              <i className="ri-bar-chart-2-line text-xl text-[#00d9ff]"></i>
            </div>
            <div>
              <p className="text-white/80 text-base md:text-lg italic leading-relaxed">
                "Kullanıcının hangi kampanyayı incelediği ve nerede kaldığı panelden takip edilir"
              </p>
              <p className="text-[#d4af37] text-sm mt-2 font-medium">— Gerçek zamanlı analiz sistemi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
